import { makeStyles, createStyles } from '@material-ui/core';
import React from 'react';
import { Trans } from 'react-i18next';

export const SupportContacts: React.FC = () => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.contact}>
        <Trans i18nKey="subscriber:supportContacts.email">
          Email:
          <br />
          <a href={'mailto:connections@veriforce.com'} className={classes.link}>
            connections@veriforce.com
          </a>
        </Trans>
      </div>
      <div className={classes.contact}>
        <Trans i18nKey="subscriber:supportContacts.phone">
          Phone:
          <br />
          <a href={'tel:832-730-1910'} className={classes.link}>
            832-730-1910
          </a>
        </Trans>
      </div>
    </>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    contact: {
      marginBottom: '10px'
    },
    link: {
      color: 'var(--primary-blue-six)',
      fontWeight: 'normal'
    }
  })
);
